import { type ProgramTheme } from "../lib/types/types";
import { RewardDisplayEnum } from "../lib/types/runtimeTypes";

/**
 * A complete student `ProgramTheme` for mock-program mode, standing in for the theme fetch when
 * there is no programId (see `lib/state/mockProgram`).
 *
 * It has to be *complete*, not a partial: `GetEmptyTheme()` has no `config`, and
 * `enhanceOrganizationFromTheme` reads `config.orgRemoteSource` unguarded, which kills the mount
 * before any step renders. `themeChoices.landingPage` is present for the same reason — the layout
 * lookup in `NewVerificationInnerComponent` only optional-chains as far as `themeChoices`.
 *
 * Branding is left unset on purpose. MySheerID layers the customer's choices on top via
 * `setPreviewBranding`, and the preview should show jslib's defaults until it does.
 */
export const mockProgramTheme: ProgramTheme = {
  intl: {
    locale: "en-US",
    messages: {
      companyName: "Your Company",
    },
  },
  customCss: "",
  privacyPolicyUrl: "https://www.sheerid.com/privacy-policy/",
  isTestMode: false, // a test-mode banner would be noise in a theme preview
  openOrgSearchEnabled: false,
  docUploadEnabled: true,
  smsLoopEnabled: false,
  overrideEnabled: false,
  threatMetrixEnabled: false,
  ipqsDeviceFingerprintEnabled: false,
  idCheckAddOnEnabled: false,
  externalUserIdRequired: false,
  remainingRewardCodes: null,
  config: {
    countries: ["US"],
    locales: ["en-US"],
    maxReviewTime: "20_MIN",
    estimatedReviewTime: "A_FEW_MINUTES",
    marketConsent: {
      enabled: false,
      required: false,
      message: "",
    },
    customMetadata: {
      enabled: false,
      keys: [],
      requiredKeys: [],
    },
    customFaqLink: null,
    brandInfo: {
      faqUrl: null,
      emailAddress: null,
      phoneNumber: null,
    },
    // Never called — the preview is not interactive — but it has to be a well-formed URL so
    // `getOrgSearchUrl` doesn't log an error on every render of a collect step.
    orgSearchUrl: "https://orgsearch.sheerid.net/rest/organization/search?country=US&name=",
    orgRemoteSource: null,
    orgTypes: ["UNIVERSITY", "POST_SECONDARY"],
    excludedOrganizationIds: [],
    rewardDisplay: [RewardDisplayEnum.TEXT],
    offerType: "staticCode",
    minAge: null,
    maxAge: null,
    segment: "student",
  },
  themeChoices: {
    landingPage: {
      layout: "center",
    },
  },
};
